import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchCurrentUserInfo () {
  return fetch('/foreignTravel/personnel/currentUser')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the current user information');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve current user information. Please reload the page and try again');
    });
}

const useCurrentUserInfo = () => {
  const value = useQuery({
    queryKey: ['useCurrentUserInfo'],
    queryFn: fetchCurrentUserInfo,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
  return value;
};

export default useCurrentUserInfo;
